export default __webpack_public_path__ + "static/media/icon2.0cfacc62.svg";